import { createContext, useContext, useState, lazy, Suspense, type ReactNode } from "react";
import { trackEvent } from "@/lib/analytics";
const QuoteDialog = lazy(() => import("./QuoteDialog"));
type QuoteContextType = { isOpen: boolean; openQuote: (products?: string[]) => void; closeQuote: () => void };
const QuoteContext = createContext<QuoteContextType | undefined>(undefined);
export function useQuote() {
  const value = useContext(QuoteContext);
  if (!value) throw new Error("useQuote must be used within a QuoteProvider");
  return value;
}
export function QuoteProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [initialProducts, setInitialProducts] = useState<string[]>([]);
  const [hasOpened, setHasOpened] = useState(false);
  const closeQuote = () => setIsOpen(false);
  const openQuote = (products: string[] = []) => {
    if (!isOpen) {
      const path = window.location.pathname.replace(/\/$/, "") || "/";
      trackEvent("quote_opened", {
        source: path === "/" ? "home" : path === "/catalogue" ? "catalogue" :
          path.startsWith("/services/") ? "service" : "other",
        preselected: products.length > 0,
      });
    }
    setInitialProducts(products);
    setHasOpened(true);
    setIsOpen(true);
  };
  return <QuoteContext.Provider value={{ isOpen, openQuote, closeQuote }}>
    {children}
    {hasOpened && <Suspense fallback={null}><QuoteDialog open={isOpen}
      onOpenChange={open => !open && closeQuote()} initialProducts={initialProducts} /></Suspense>}
  </QuoteContext.Provider>;
}
